module.exports = __webpack_public_path__ + "img/5Z.8c40ece3.png";